let input = $('.quantity input');

input.attr('type', 'text');
input.before('<a href="#" class="btn btn-outline-secondary rounded-circle qty-decrease">-</a>');
input.after('<a href="#" class="btn btn-outline-secondary rounded-circle qty-increase">+</a>');

// Increase quantity.
$(document).on('click', '.qty-increase', function(e) {
	e.preventDefault();

	if (input.val() < input.attr('max') ) {
		input.val( function(i, oldval) {
			return parseInt( oldval, 10) + 1;
		});
	}
});

// Decrease quantity.
$(document).on('click', '.qty-decrease', function(e) {
	e.preventDefault();

	if (input.val() > input.attr('min') ) {
		input.val( function(i, oldval) {
			return parseInt( oldval, 10) - 1;
		});
	}
});
